import {
  GRANULARITY_LABEL, RESOLUTION_HINT, RESOLUTION_LABEL,
  type Granularity,
} from '../../../shared/types/config.js'
import type { HomogeneityGrade, ResolutionGrade } from '../../../shared/types/domain.js'
import { Pill } from './ui.js'

// §8.6 ResolutionBadge / GranularityBadge。兩者都要有 tooltip 說明判定依據。

export function ResolutionBadge({ grade, reason }: { grade: ResolutionGrade; reason?: string }) {
  const tone = grade === 'R1' ? 'emerald' : grade === 'R2' ? 'sky' : 'amber'
  return (
    <Pill tone={tone} title={`${grade} ${RESOLUTION_LABEL[grade]}｜${reason ?? RESOLUTION_HINT[grade]}`}>
      <span className="font-semibold">{grade}</span>
      <span className="opacity-80">{RESOLUTION_LABEL[grade]}</span>
      {(grade === 'R3' || grade === 'R4') && <span aria-hidden>⚠</span>}
    </Pill>
  )
}

export function HomogeneityBadge({ grade, reason }: { grade: HomogeneityGrade; reason?: string }) {
  const tone = grade === 'A' ? 'emerald' : grade === 'B' ? 'sky' : 'amber'
  const label = grade === 'A' ? '單一型號' : grade === 'B' ? '兩種型號' : '多型號混批'
  return (
    <Pill tone={tone} title={`同質性 ${grade}｜${reason ?? label}`}>
      <span className="font-semibold">同質性 {grade}</span>
      <span className="opacity-80">{label}</span>
    </Pill>
  )
}

export function GranularityBadge({ g, mpId }: { g: Granularity; mpId?: string }) {
  return (
    <Pill
      tone={g === 'panel' ? 'violet' : 'ink'}
      title={g === 'panel'
        ? `逐片秤：每片各記一筆 WeighEvent，panelId 有值${mpId ? `（量測點 ${mpId}）` : ''}`
        : `整批秤：整批記一筆 WeighEvent，panelId = null${mpId ? `（量測點 ${mpId}）` : ''}`}
    >
      {GRANULARITY_LABEL[g]}
      <span aria-hidden className="opacity-60">ⓘ</span>
    </Pill>
  )
}

export function WeightSourceBadge({ src }: { src: 'measured' | 'booked' | 'derived' }) {
  const label = src === 'measured' ? '實秤' : src === 'booked' ? '帳面繼承' : '推導'
  return <Pill tone={src === 'measured' ? 'emerald' : 'ink'} title={`重量來源：${label}`}>{label}</Pill>
}
